// wishlist.js
(function () {
  var STORAGE_KEY = 'wishlist_v1';
  var TOKEN_KEY = 'wishlist_token';
  var API_BASE = 'https://wishlist.shopsdata.store';
  var SHOP_DOMAIN = window.__SHOP_DOMAIN__ || ''; // 部署后替换为真实地址

  // ─── 收藏埋点（统计收藏带来的价值）────────────────────────
  // 你提供的 store_id（后续如果要多店铺，可改成 window.__STORE_ID__ 注入）
  var STORE_ID = '0ebaf504-4761-4037-ae82-d582c927738e';
  // 走 wishlist 服务端转发，避免浏览器跨域 CORS 导致只发出 preflight
  var TRACK_ENDPOINT = 'https://wishlist.shopsdata.store/api/track';

  function getSessionId() {
    var sid = window.localStorage.getItem('session_id');
    if (!sid) {
      sid = Math.random().toString(36).slice(2);
      window.localStorage.setItem('session_id', sid);
    }
    return sid;
  }

  function reportShopifyEvent(eventName, eventData) {
    // 埋点不要阻塞主流程
    try {
      fetch(TRACK_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event: eventName,
          timestamp: new Date().toISOString(),
          store_id: STORE_ID,
          session_id: getSessionId(),
          user_id: '',
          url: window.location.href,
          referrer: document.referrer,
          user_agent: navigator.userAgent,
          data: eventData || {},
        }),
      });
    } catch (e) {
      // 静默失败，避免影响收藏功能
    }
  }

  // ─── 本地存储 ────────────────────────────────────────────
  var Wishlist = {
    load: function () {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return { items: [] };
        var data = JSON.parse(raw);
        if (!Array.isArray(data.items)) return { items: [] };
        return data;
      } catch (e) {
        return { items: [] };
      }
    },

    save: function (data) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch (e) {
        console.error('Wishlist save error', e);
      }
    },

    list: function () {
      return this.load().items;
    },

    isInWishlist: function (variantId) {
      var id = String(variantId);
      return this.list().some(function (item) {
        return String(item.variantId) === id;
      });
    },

    add: function (item) {
      var data = this.load();
      var id = String(item.variantId);
      if (!data.items.find(function (i) { return String(i.variantId) === id; })) {
        data.items.push({
          productId: String(item.productId),
          variantId: id,
          productHandle: item.productHandle ? String(item.productHandle) : undefined,
          productTitle: item.productTitle ? String(item.productTitle) : undefined,
          addedAt: new Date().toISOString(),
        });
        this.save(data);
        // 埋点：收藏新增
        try {
          reportShopifyEvent('wishlist_added', {
            product_id: item.productId,
            variant_id: id,
            product_handle: item.productHandle,
            wishlist_count: data.items.length,
          });
        } catch (e) {}
        this._onChanged();
      }
    },

    remove: function (variantId) {
      var data = this.load();
      var id = String(variantId);
      var removedItem = null;
      data.items.forEach(function (i) {
        if (String(i.variantId) === id) removedItem = i;
      });
      data.items = data.items.filter(function (i) { return String(i.variantId) !== id; });
      this.save(data);
      // 埋点：收藏移除
      try {
        reportShopifyEvent('wishlist_removed', {
          product_id: removedItem ? removedItem.productId : null,
          variant_id: id,
          product_handle: removedItem ? removedItem.productHandle : null,
          wishlist_count: data.items.length,
        });
      } catch (e) {}
      this._onChanged();
    },

    clear: function () {
      var beforeCount = this.list().length;
      this.save({ items: [] });
      // 埋点：清空愿望清单（如果你后面有清空按钮，这里会统计）
      try {
        if (beforeCount > 0) {
          reportShopifyEvent('wishlist_cleared', { wishlist_count: 0 });
        }
      } catch (e) {}
      this._onChanged();
    },

    // ─── Token ────────────────────────────────────────────
    getToken: function () {
      return window.localStorage.getItem(TOKEN_KEY) || null;
    },

    setToken: function (token) {
      window.localStorage.setItem(TOKEN_KEY, token);
    },

    // ─── 角标 ────────────────────────────────────────────
    updateBadge: function () {
      var count = this.list().length;
      // 更新数字
      document.querySelectorAll('.js-wishlist-count').forEach(function (el) {
        el.textContent = count > 0 ? count : '';
      });
      // 显示/隐藏气泡容器（复用购物车的 cart-count-bubble 样式）
      document.querySelectorAll('.js-wishlist-bubble').forEach(function (el) {
        el.style.display = count > 0 ? '' : 'none';
      });
    },

    // ─── 收藏变化时统一处理 ────────────────────────────────
    _onChanged: function () {
      this.updateBadge();
      var token = this.getToken();
      var items = this.list();
      // 有邮箱（token）才同步
      if (token) {
        this._syncToServer(token, items);
      }
    },

    // ─── 后端同步 ─────────────────────────────────────────
    _syncToServer: function (token, items) {
      fetch(API_BASE + '/api/wishlist/save', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: token, items: items, shop: SHOP_DOMAIN }),
      }).catch(function (e) {
        console.error('Wishlist sync error', e);
      });
    },

    // 注册邮箱获取 token
    registerEmail: function (email) {
      var self = this;
      return fetch(API_BASE + '/api/wishlist/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email }),
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.token) {
            self.setToken(data.token);
            // 无论收藏是否为空都同步一次，确保 Klaviyo 属性更新
            var items = self.list();
            self._syncToServer(data.token, items);
            return data.token;
          }
          return null;
        })
        .catch(function (e) {
          console.error('Wishlist register error', e);
          return null;
        });
    },

    // 用 token 从服务端加载并合并
    loadFromServer: function (token, shopDomain) {
      var self = this;
      var shop = shopDomain || SHOP_DOMAIN;
      return fetch(API_BASE + '/api/wishlist/load?token=' + encodeURIComponent(token) + '&shop=' + encodeURIComponent(shop))
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (!data.items) return;
          var localData = self.load();
          var map = new Map();
          localData.items.forEach(function (i) { map.set(String(i.variantId), i); });
          data.items.forEach(function (i) {
            var key = String(i.variantId);
            if (!map.has(key)) map.set(key, i);
          });
          self.save({ items: Array.from(map.values()) });
          self.updateBadge();
        })
        .catch(function (e) {
          console.error('Wishlist loadFromServer error', e);
        });
    },
  };

  window.Wishlist = Wishlist;

  // ─── DOMContentLoaded ──────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    // 初始化角标
    Wishlist.updateBadge();

    // 如果已有 token，从服务端同步
    var existingToken = Wishlist.getToken();
    if (existingToken) {
      Wishlist.loadFromServer(existingToken, SHOP_DOMAIN);
    }

    // 初始化按钮状态
    document.querySelectorAll('.js-wishlist-toggle').forEach(function (btn) {
      var variantId = btn.dataset.variantId;
      if (Wishlist.isInWishlist(variantId)) {
        btn.classList.add('is-active');
      }
    });

    // 收藏按钮点击（全站通用）
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.js-wishlist-toggle');
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();

      var productId = btn.dataset.productId;
      var variantId = btn.dataset.variantId;
      var productHandle = btn.dataset.productHandle;
      var productTitle = btn.dataset.productTitle;

      if (!variantId) return;

      if (Wishlist.isInWishlist(variantId)) {
        Wishlist.remove(variantId);
        btn.classList.remove('is-active');
      } else {
        Wishlist.add({ productId: productId, variantId: variantId, productHandle: productHandle, productTitle: productTitle });
        btn.classList.add('is-active');
      }
    });

    // ─── Klaviyo 表单提交监听 ──────────────────────────────
    window.addEventListener('klaviyoForms', function (e) {
      if (!e.detail || e.detail.type !== 'submit') return;

      var email = e.detail.metaData && e.detail.metaData.$email;
      if (!email) return;

      // 无论收藏是否为空都注册 token（方便后续收藏时同步）
      Wishlist.registerEmail(email).then(function (token) {
        if (!token) return;
        // 如果当前有收藏，同步已由 registerEmail 内部触发
        // 更新 URL（方便用户书签）
        var items = Wishlist.list();
        if (items.length > 0 && window.location.pathname.includes('/pages/wishlist')) {
          var url = new URL(window.location.href);
          url.searchParams.set('token', token);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  });
})();
